import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import { headerEmpresa } from '../../helpers/headerEmpresa';
import { getEmpresa } from '../../../services/empresaService';

async function ValorVendaPdf(produtos) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    // Busca dados da empresa (global)
    const empresa = await getEmpresa();

    // Cabeçalhos da tabela
    const tableHeader = [
        { text: 'Código', style: 'tableHeader' },
        { text: 'Descrição', style: 'tableHeader' },
        { text: 'Unidade', style: 'tableHeader' },
        { text: 'Valor de Venda', style: 'tableHeader', alignment: 'right' }
    ];

    // Linhas da tabela
    const tableBody = produtos.map(produto => ([
        { text: produto.COD_PRODUTO, style: 'tableData' },
        { text: produto.DESCRICAO, style: 'tableData' },
        { text: produto.UNIDADE, style: 'tableData' },
        {
            text: `R$ ${Number(produto.VENDA).toFixed(2).replace('.', ',')}`,
            style: 'tableData',
            alignment: 'right'
        }
    ]));

    const docDefinition = {
        pageSize: 'A4',
        pageMargins: [40, 60, 40, 60],

        // ✅ Cabeçalho global reutilizável
        header: headerEmpresa(empresa),

        content: [
            {
                text: 'Relatório de Valor de Venda de Produtos',
                style: 'header',
                margin: [0, 10, 0, 20]
            },

            {
                table: {
                    headerRows: 1,
                    widths: ['auto', '*', 'auto', 'auto'],
                    body: [
                        tableHeader,
                        ...tableBody
                    ]
                },
                layout: {
                    fillColor: (rowIndex) =>
                        rowIndex === 0
                            ? '#eeeeee'
                            : rowIndex % 2 === 0
                                ? '#f9f9f9'
                                : null,
                    hLineWidth: () => 0.5,
                    vLineWidth: () => 0.5,
                    hLineColor: () => '#cccccc',
                    vLineColor: () => '#cccccc'
                }
            }
        ],

        footer: (currentPage, pageCount) => ({
            text: `${currentPage} / ${pageCount}`,
            alignment: 'right',
            fontSize: 9,
            margin: [0, 10, 40, 0]
        }),

        styles: {
            header: {
                fontSize: 16,
                bold: true,
                alignment: 'center'
            },
            tableHeader: {
                bold: true,
                fontSize: 12,
                color: '#333'
            },
            tableData: {
                fontSize: 11,
                color: '#444'
            }
        }
    };

    pdfMake.createPdf(docDefinition).open();
}

export default ValorVendaPdf;